export const formattedPrice = price => `$${parseFloat(price).toFixed(2).toString()}`;
